import React, { useState, useEffect, useCallback } from "react";
import AdminLogo from "../../../Assets/Icons/Admin logo.svg";
import MerchantLogo from "../../../Assets/Icons/Merchant logo.svg";
import FundraiserLogo from "../../../Assets/Icons/Fundraiser logo.svg";
import DashboardActive from "../../../Assets/Icons/DashboardActive.svg";
import DashboardInActive from "../../../Assets/Icons/DashboardInActive.svg";
import MerchantsActive from "../../../Assets/Icons/MerchantsActive.svg";
import MerchantsInActive from "../../../Assets/Icons/MerchantsInActive.svg";
import FundraisersActive from "../../../Assets/Icons/FundraiserActive.svg";
import FundraisersInActive from "../../../Assets/Icons/FundraiserInActive.svg";
import OffersActive from "../../../Assets/Icons/OffersActive.svg";
import OffersInActive from "../../../Assets/Icons/OffersInActive.svg";
import PromotionsActive from "../../../Assets/Icons/PromotionsActive.svg";
import PromotionsInActive from "../../../Assets/Icons/PromotionsInActive.svg";
import TransactionsInActive from "../../../Assets/Icons/TransactionsInActive.svg";
import TransactionsActive from "../../../Assets/Icons/TransactionsActive.svg";
import BankActive from "../../../Assets/Icons/BankActive.svg";
import BankInActive from "../../../Assets/Icons/BankInActive.svg";
import ReferActive from "../../../Assets/Icons/ReferActive.svg";
import ReferInActive from "../../../Assets/Icons/ReferInActive.svg";
import MarketActive from "../../../Assets/Icons/marketingActive.svg";
import MarketInactive from "../../../Assets/Icons/marketingInactive.svg";
import RedemptionActive from "../../../Assets/Icons/redemptionIconActive.svg";
import RedemptionInActive from "../../../Assets/Icons/redemptionInactive.svg";
import UsersActive from "../../../Assets/Icons/UserActive.svg";
import UsersInActive from "../../../Assets/Icons/UserInActive.svg";
import MerchantVisibilityIcon from "../../../Assets/Icons/MerchantVisibilityIcon.svg";

import { ExpandMoreOutlined } from "@mui/icons-material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./sidebar.scss";
import { roleEnum } from "../../../utils/utilFunctions";
import BusinessSwitcher from "./BusinessSwitcher";
import { useSelector, useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { getMerchantProfiles } from "../../../services/merchantService";

// Import the getMerchantProfiles action/thunk

const CustomSidebar = ({ isSideBarOpen, setisSideBarOpen }) => {
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState("");

  // Get user role from authReducer
  const userAuthData = useSelector((state) => state.authReducer.tokenData?.user);
  // Get merchant profiles from merchantReducer (this is the dynamic, up-to-date source)
  const merchantProfilesFromRedux = useSelector((state) => state.merchantReducer.merchantProfiles?.data);

  const dispatch = useDispatch();

  const closeSidebarIfMobile = () => {
    if (window.innerWidth <= 768) {
      setisSideBarOpen(false);
    }
  };

  useEffect(() => {
    setActiveRoute(location.pathname);
    // Close all dropdowns when route changes
    closeOtherDropdowns('');
  }, [location]);
  useEffect(() => {
    if (activeRoute === "/dashboard" || activeRoute === "/merchant/dashboard") {
      setSelected("");
      setSelectedList("Dashboard");
    } else if (activeRoute === "/offer-form" || activeRoute === "/merchant/offer-form" || activeRoute.includes("offer-form")) {
      // When on offer form, set selectedList to "Offers" to highlight parent menu
      setSelectedList("Offers");
      setIsOfferListOpen(true);
    } else if (activeRoute === "/offer-list" || activeRoute === "/merchant/offer-list") {
      setSelectedList("Offers");
      setIsOfferListOpen(true);
    } else if (activeRoute === "/merchant-list" || activeRoute === "/invitation-list") {
      setSelectedList("Merchants");
      setIsMerchantListOpen(true);
    } else if (activeRoute === "/fundraiser-list") {
      setSelectedList("Fundraisers");
      setIsFundraiserListOpen(true);
    } else if (activeRoute === "/user-list") {
      setSelectedList("Users");
      setIsUserListOpen(true);
    } else if (activeRoute === "/merchant/franchise-form" || activeRoute === "/merchant/franchise-list") {
      setSelectedList("Franchise");
      setIsFranchiseOpen(true);
    }
  }, [activeRoute]);

  // --- useEffect to fetch merchant profiles when user role is merchant ---
  useEffect(() => {
    // Only fetch profiles if the user is logged in and is a merchant
    // This ensures that merchantProfilesFromRedux gets populated
    if (userAuthData?.role === "merchant" && userAuthData?._id) {
      dispatch(getMerchantProfiles({ id: userAuthData?._id }));
    }
  }, [dispatch, userAuthData?._id, userAuthData?.role]);

  const [isMerchantListOpen, setIsMerchantListOpen] = useState(false);
  const [isFundraiserListOpen, setIsFundraiserListOpen] = useState(false);
  const [isOfferListOpen, setIsOfferListOpen] = useState(false);
  const [isAssetsOpen, setIsAssetsOpen] = useState(false);
  const [isFranchiseOpen, setIsFranchiseOpen] = useState(false);
  const [isTransactionsOpen, setIsTransactionsOpen] = useState(false);
  const [isBankOpen, setIsBankOpen] = useState(false);
  const [isReferOpen, setIsReferOpen] = useState(false);
  const [isUserListOpen, setIsUserListOpen] = useState(false);

  const [selected, setSelected] = useState("");
  const [selectedList, setSelectedList] = useState("Dashboard");

  // Function to close all other dropdowns when a new one is opened
  const closeOtherDropdowns = useCallback((currentDropdown) => {
    if (currentDropdown !== 'merchant') setIsMerchantListOpen(false);
    if (currentDropdown !== 'fundraiser') setIsFundraiserListOpen(false);
    if (currentDropdown !== 'offer') setIsOfferListOpen(false);
    if (currentDropdown !== 'assets') setIsAssetsOpen(false);
    if (currentDropdown !== 'franchise') setIsFranchiseOpen(false);
    if (currentDropdown !== 'transactions') setIsTransactionsOpen(false);
    if (currentDropdown !== 'bank') setIsBankOpen(false);
    if (currentDropdown !== 'refer') setIsReferOpen(false);
    if (currentDropdown !== 'user') setIsUserListOpen(false);
  }, []);

  // Persist sidebar open groups and selected item across refreshes
  const SIDEBAR_STORE_KEY = "SIDEBAR_STATE_V1";

  // Rehydrate on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(SIDEBAR_STORE_KEY);
      if (raw) {
        const saved = JSON.parse(raw);
        if (typeof saved?.isMerchantListOpen === "boolean") setIsMerchantListOpen(saved.isMerchantListOpen);
        if (typeof saved?.isFundraiserListOpen === "boolean") setIsFundraiserListOpen(saved.isFundraiserListOpen);
        if (typeof saved?.isOfferListOpen === "boolean") setIsOfferListOpen(saved.isOfferListOpen);
        if (typeof saved?.isAssetsOpen === "boolean") setIsAssetsOpen(saved.isAssetsOpen);
        if (typeof saved?.isFranchiseOpen === "boolean") setIsFranchiseOpen(saved.isFranchiseOpen);
        if (typeof saved?.isTransactionsOpen === "boolean") setIsTransactionsOpen(saved.isTransactionsOpen);
        if (typeof saved?.isBankOpen === "boolean") setIsBankOpen(saved.isBankOpen);
        if (typeof saved?.isReferOpen === "boolean") setIsReferOpen(saved.isReferOpen);
        if (typeof saved?.isUserListOpen === "boolean") setIsUserListOpen(saved.isUserListOpen);
        if (typeof saved?.selected === "string") setSelected(saved.selected);
        if (typeof saved?.selectedList === "string") setSelectedList(saved.selectedList);
      }
    } catch (_) { }
  }, []);

  // Function to open the dropdown for the currently selected section
  const openDropdownForSelectedSection = useCallback(() => {
    if (selectedList === "Merchants") {
      setIsMerchantListOpen(true);
      closeOtherDropdowns('merchant');
    } else if (selectedList === "Fundraisers") {
      setIsFundraiserListOpen(true);
      closeOtherDropdowns('fundraiser');
    } else if (selectedList === "Users") {
      setIsUserListOpen(true);
      closeOtherDropdowns('user');
    } else if (selectedList === "Offers") {
      setIsOfferListOpen(true);
      closeOtherDropdowns('offer');
    } else if (selectedList === "Assets") {
      setIsAssetsOpen(true);
      closeOtherDropdowns('assets');
    } else if (selectedList === "Franchise") {
      setIsFranchiseOpen(true);
      closeOtherDropdowns('franchise');
    } else if (selectedList === "Refer") {
      setIsReferOpen(true);
      closeOtherDropdowns('refer');
    }
  }, [selectedList, closeOtherDropdowns]);

  // Open dropdown for selected section when selectedList changes
  useEffect(() => {
    openDropdownForSelectedSection();
  }, [selectedList, openDropdownForSelectedSection]);

  // Save whenever toggles or selection change
  useEffect(() => {
    try {
      localStorage.setItem(
        SIDEBAR_STORE_KEY,
        JSON.stringify({
          isMerchantListOpen,
          isFundraiserListOpen,
          isOfferListOpen,
          isAssetsOpen,
          isFranchiseOpen,
          isTransactionsOpen,
          isBankOpen,
          isReferOpen,
          isUserListOpen,
          selected,
          selectedList,
        })
      );
    } catch (_) { }
  }, [
    isMerchantListOpen,
    isFundraiserListOpen,
    isOfferListOpen,
    isAssetsOpen,
    isFranchiseOpen,
    isTransactionsOpen,
    isBankOpen,
    isReferOpen,
    isUserListOpen,
    selected,
    selectedList,
  ]);

  const navigate = useNavigate();
  const guardExit = (path) => {
    if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
      window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path } }));
      return true;
    }
    return false;
  };
  const safeNavigate = (path) => {
    if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
      window.dispatchEvent(
        new CustomEvent("attempt-exit-offer-form", { detail: { path } })
      );
      return;
    }
    closeSidebarIfMobile();
    navigate(path);
  };

  // --- CRITICAL CHANGE: Determine if BusinessSwitcher should be shown ---
  // Based on your clarification: "when there will be 2 merchantProfile only when teh Switcher is visvible"
  // This means if length is 0 or 1, show the button. If length is 2 or more, show the switcher.
  const hasProfilesFromAuth = userAuthData?.merchantProfiles && userAuthData.merchantProfiles.length > 1; // Check for > 1
  const hasProfilesFromReduxFetch = merchantProfilesFromRedux && merchantProfilesFromRedux.length > 1; // Check for > 1

  const shouldShowBusinessSwitcher = hasProfilesFromAuth || hasProfilesFromReduxFetch;

  // Determine if we are currently editing an offer
  const isEditingOffer = location.pathname.includes("offer-form") && (location.state?.id || location.state?.offerId);

  useEffect(() => {
    if (isEditingOffer) {
      setSelected("Edit an Offer");
      setSelectedList("Offers");
      setIsOfferListOpen(true);
    }
  }, [isEditingOffer]);

  return isSideBarOpen ? (
    <div className="sidebar-container fixed top-[72px] left-0 w-full h-[calc(100vh-72px)] z-50 md:relative md:top-0 md:w-[40%] md:h-auto lg:w-[25%] xl:w-[20%] z-10 shadow-[4px_4px_10px_0px_rgba(0,0,0,0.15)] bg-white">
      {activeRoute.includes(roleEnum.merchant) ? (
        <div
          className="h-[100vh] overflow-y-scroll"
          style={{ scrollbarWidth: "none" }}
        >
          <div className=" px-5 lg:px-[10%] py-4 lg:py-[8%] mb-3">
            <img
              className="w-[150px] sm:w-[180px] md:w-[82%] xl:w-[60%]"
              src={MerchantLogo}
              alt="merchant"
            ></img>
          </div>
          {shouldShowBusinessSwitcher ? (
            <BusinessSwitcher />
          ) : (
            // Show this button if there are 0 or 1 merchant profiles
            <div className="w-full">
              <button
                className="flex items-center justify-center bg-[#00ADEF] text-white font-semibold text-[15px] h-[36px] rounded-[4px] transition-colors duration-150 hover:bg-[#0095c8] w-[80%] mx-auto mb-4"
                style={{
                  boxShadow: "0 2px 8px rgba(0,173,239,0.10)",
                  letterSpacing: 0.1,
                  gap: 6,
                }}
                onClick={() => {
                  if (guardExit("/merchant/getting-started")) return;
                  navigate("/merchant/getting-started");
                }}
              >
                <span className="flex items-center justify-center w-3 h-3 rounded-full bg-white mr-1">
                  <PlusOutlined className="text-[#00ADEF] text-[8px]" />
                </span>
                Create New Business
              </button>
            </div>
          )}
          {/* Rest of your sidebar menu items */}
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/merchant/dashboard" || selectedList === "Dashboard"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (guardExit("/merchant/dashboard")) return;
              setSelected("");
              setSelectedList("Dashboard");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/merchant/dashboard");
            }}
          >
            <img
              src={
                activeRoute === "/merchant/dashboard"
                  ? DashboardActive
                  : DashboardInActive
              }
              alt="Dashboard"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Dashboard</p>
          </div>
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Offers" || isOfferListOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isOfferListOpen) {
                closeOtherDropdowns('offer');
              }
              setIsOfferListOpen(!isOfferListOpen);
            }}
          >
            <img
              src={selectedList === "Offers" || isOfferListOpen ? OffersActive : OffersInActive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Offers</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isOfferListOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: (selectedList === "Offers" || isOfferListOpen) ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isOfferListOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/merchant/offer-form"}
                className={
                  activeRoute === "/merchant/offer-form"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/merchant/offer-form" } }));
                    return;
                  }
                  setSelected(isEditingOffer ? "Edit an Offer" : "Create an Offer");
                  setSelectedList("Offers");
                  // Keep the offer dropdown open
                  setIsOfferListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                {isEditingOffer ? "Edit an Offer" : "Create an Offer"}
              </Link>
              <Link
                to={"/merchant/offer-list"}
                className={
                  activeRoute === "/merchant/offer-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/merchant/offer-list" } }));
                    return;
                  }
                  setSelected("Offers List");
                  setSelectedList("Offers");
                  // Keep the offer dropdown open
                  setIsOfferListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Offers List
              </Link>
            </div>
          )}
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Franchise" || isFranchiseOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isFranchiseOpen) {
                closeOtherDropdowns('franchise');
              }
              setIsFranchiseOpen(!isFranchiseOpen);
            }}
          >
            <img
              src={
                selectedList === "Franchise" || isFranchiseOpen
                  ? MerchantsActive
                  : MerchantsInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Other Stores</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isFranchiseOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Franchise" || isFranchiseOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isFranchiseOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/merchant/franchise-form"}
                className={
                  activeRoute === "/merchant/franchise-form"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (guardExit("/merchant/franchise-form")) { e.preventDefault(); return; }
                  setSelected("Add a Franchise");
                  setSelectedList("Franchise");
                  // Keep the franchise dropdown open
                  setIsFranchiseOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Add Store
              </Link>
              <Link
                to={"/merchant/franchise-list"}
                className={
                  activeRoute === "/merchant/franchise-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (guardExit("/merchant/franchise-list")) { e.preventDefault(); return; }
                  setSelected("Franchise List");
                  setSelectedList("Franchise");
                  // Keep the franchise dropdown open
                  setIsFranchiseOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Stores List
              </Link>
            </div>
          )}
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/merchant/redemption"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (guardExit("/merchant/redemption")) return;
              setSelected("");
              setSelectedList("Redemption");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/merchant/redemption");
            }}
          >
            <img
              src={
                activeRoute === "/merchant/redemption"
                  ? RedemptionActive
                  : RedemptionInActive
              }
              alt="Redemption"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Redemption</p>
          </div>
        </div>
      ) : activeRoute.includes(roleEnum.fundraiser) ? (
        <div
          className="h-[100vh] overflow-y-scroll"
          style={{ scrollbarWidth: "none" }}
        >
          <div className=" px-5 lg:px-[10%] py-4 lg:py-[8%] mb-3">
            <img
              className="w-[150px] sm:w-[180px] md:w-[82%] xl:w-[60%]"
              src={FundraiserLogo}
              alt="fundraiser"
            ></img>
          </div>
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/fundraiser/dashboard" || selectedList === "Dashboard"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Dashboard");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/fundraiser/dashboard");
            }}
          >
            <img
              src={
                activeRoute === "/fundraiser/dashboard"
                  ? DashboardActive
                  : DashboardInActive
              }
              alt="Dashboard"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Fundraiser Dashboard</p>
          </div>
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/fundraiser/transactions"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Transactions");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/fundraiser/transactions");
            }}
          >
            <img
              src={
                activeRoute === "/fundraiser/transactions"
                  ? TransactionsActive
                  : TransactionsInActive
              }
              alt="Transactions"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Transactions</p>
          </div>
          {/* <div
            className={`px-5 lg:px-[10%] flex py-4 lg:py-[8%] items-center ${
              selectedList === "Transactions"
                ? "listItemDiv selectedListItem"
                : "listItemDiv"
            }`}
          >
            <img
              src={
                selectedList === "Transactions"
                  ? TransactionsActive
                  : TransactionsInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Transactions</p>
            <ExpandMoreOutlined
              className={`ms-auto cursor-pointer ${
                isTransactionsOpen ? "transform rotate-180" : ""
              }`}
              onClick={() => setIsTransactionsOpen(!isTransactionsOpen)}
            />
          </div>
          {isTransactionsOpen && (
            <div className="gap-3 flex flex-col justify-between ps-[71px] mt-1">
              <Link
                to={"/fundraiser/deposited-funds"}
                className={
                  activeRoute === "/fundraiser/deposited-funds"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Funds Deposited");
                  setSelectedList("Transactions");
                }}
              >
                Funds Deposited
              </Link>
              <Link
                to={"/fundraiser/withdrawals"}
                className={
                  activeRoute === "/fundraiser/withdrawals"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Withdrawals");
                  setSelectedList("Transactions");
                }}
              >
                Withdrawals
              </Link>
              <Link
                to={"/fundraiser/withdraw"}
                className={
                  activeRoute === "/fundraiser/withdraw"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Withdraw");
                  setSelectedList("Transactions");
                }}
              >
                Withdraw
              </Link>
            </div>
          )} */}
          {/* <div
            className={` px-5 lg:px-[10%] flex py-4 lg:py-[8%] items-center ${
              selectedList === "Bank"
                ? "listItemDiv selectedListItem"
                : "listItemDiv"
            }`}
          >
            <img
              src={selectedList === "Bank" ? BankActive : BankInActive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Connect with the Bank</p>
            <ExpandMoreOutlined
              className={`ms-auto cursor-pointer ${
                isBankOpen ? "transform rotate-180" : ""
              }`}
              onClick={() => setIsBankOpen(!isBankOpen)}
            />
          </div> */}
          {isBankOpen && (
            <div className="gap-3 flex flex-col justify-between ps-[71px] mt-1">
              <Link
                to={"/fundraiser/add-bank"}
                className={
                  activeRoute === "/fundraiser/add-bank"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Add a Bank");
                  setSelectedList("Bank");
                }}
              >
                Add a Bank
              </Link>
              <Link
                to={"/fundraiser/banks-list"}
                className={
                  activeRoute === "/fundraiser/banks-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("List of Banks");
                  setSelectedList("Bank");
                }}
              >
                List of Banks
              </Link>
            </div>
          )}
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Refer" || isReferOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => setIsReferOpen(!isReferOpen)}
          >
            <img
              src={selectedList === "Refer" || isReferOpen ? ReferActive : ReferInActive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Refer a Merchant</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isReferOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Refer" || isReferOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isReferOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/fundraiser/refer-merchant"}
                className={
                  activeRoute === "/fundraiser/refer-merchant"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Refer New Merchant");
                  setSelectedList("Refer");
                  setIsReferOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Refer New Merchant
              </Link>
              <Link
                to={"/fundraiser/referral-list"}
                className={
                  activeRoute === "/fundraiser/referral-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Referral List");
                  setSelectedList("Refer");
                  setIsReferOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Referral List
              </Link>

            </div>
          )}
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/fundraiser/merchant-visibility"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("MerchantVisibility");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/fundraiser/merchant-visibility");
            }}
          >
            <img
              src={MerchantVisibilityIcon}
              alt="Merchant Visibility"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Merchant Visibility</p>
          </div>
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/fundraiser/assets"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Assets");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/fundraiser/assets");
            }}
          >
            <img
              src={
                selectedList === "Assets"
                  ? PromotionsActive
                  : PromotionsInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Marketing Assets</p>
          </div>
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/fundraiser/marketing"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Marketing");
              closeOtherDropdowns('');
              closeSidebarIfMobile();
              navigate("/fundraiser/marketing");
            }}
          >
            <img
              src={activeRoute === "/fundraiser/marketing" ? MarketActive : MarketInactive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Marketing Page</p>
          </div>
        </div>
      ) : (
        <div
          className="h-[100vh] overflow-y-scroll"
          style={{ scrollbarWidth: "none" }}
        >
          <div className=" px-5 lg:px-[10%] py-4 lg:py-[8%] mb-3">
            <img
              className="w-[150px] sm:w-[180px] md:w-[82%] xl:w-[60%]"
              src={AdminLogo}
              alt="admin"
            ></img>
          </div>
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/dashboard" || selectedList === "Dashboard"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Dashboard");
              closeOtherDropdowns('');
              safeNavigate("/dashboard");
            }}
          >
            <img
              src={
                activeRoute === "/dashboard"
                  ? DashboardActive
                  : DashboardInActive
              }
              alt="Dashboard"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Dashboard</p>
          </div>
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Merchants" || isMerchantListOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isMerchantListOpen) {
                closeOtherDropdowns('merchant');
              }
              setIsMerchantListOpen(!isMerchantListOpen);
            }}
          >
            <img
              src={
                selectedList === "Merchants" || isMerchantListOpen
                  ? MerchantsActive
                  : MerchantsInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Merchants</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isMerchantListOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Merchants" || isMerchantListOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isMerchantListOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/merchant-list"}
                className={
                  activeRoute === "/merchant-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/merchant-list" } }));
                    return;
                  }
                  setSelected("Merchant list");
                  setSelectedList("Merchants");
                  // Keep the merchant dropdown open
                  setIsMerchantListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Merchant list
              </Link>
              <Link
                to={"/invitation-list"}
                className={
                  activeRoute === "/invitation-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/invitation-list" } }));
                    return;
                  }
                  setSelected("Invites");
                  setSelectedList("Merchants");
                  // Keep the merchant dropdown open
                  setIsMerchantListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Invites
              </Link>

              {/* <Link
                to={"/referral-list"}
                className={
                  activeRoute === "/referral-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Referral List");
                  setSelectedList("Merchants");
                }}
              >
                Referral List
              </Link> */}
              {/* <Link
                to={"/merchant-inquiries"}
                className={
                  activeRoute === "/merchant-inquiries"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Inquiries");
                  setSelectedList("Merchants");
                }}
              >
                Inquiries
              </Link> */}
            </div>
          )}
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Fundraisers" || isFundraiserListOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isFundraiserListOpen) {
                closeOtherDropdowns('fundraiser');
              }
              setIsFundraiserListOpen(!isFundraiserListOpen);
            }}
          >
            <img
              src={
                selectedList === "Fundraisers" || isFundraiserListOpen
                  ? FundraisersActive
                  : FundraisersInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Fundraisers</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isFundraiserListOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Fundraisers" || isFundraiserListOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isFundraiserListOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/fundraiser-list"}
                className={
                  activeRoute === "/fundraiser-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/fundraiser-list" } }));
                    return;
                  }
                  setSelected("Fundraiser list");
                  setSelectedList("Fundraisers");
                  // Keep the fundraiser dropdown open
                  setIsFundraiserListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Fundraiser list
              </Link>
              {/* <Link
                to={"/fundraiser-inquiries"}
                className={
                  activeRoute === "/fundraiser-inquiries"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={() => {
                  setSelected("Inquiries");
                  setSelectedList("Fundraisers");
                }}
              >
                Inquiries
              </Link> */}
            </div>
          )}
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Users" || isUserListOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isUserListOpen) {
                closeOtherDropdowns('user');
              }
              setIsUserListOpen(!isUserListOpen);
            }}
          >
            <img
              src={selectedList === "Users" || isUserListOpen ? UsersActive : UsersInActive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Users</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isUserListOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Users" || isUserListOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isUserListOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/user-list"}
                className={
                  activeRoute === "/user-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/user-list" } }));
                    return;
                  }
                  setSelected("Users List");
                  setSelectedList("Users");
                  // Keep the user dropdown open
                  setIsUserListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Users List
              </Link>
            </div>
          )}
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Offers" || isOfferListOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isOfferListOpen) {
                closeOtherDropdowns('offer');
              }
              setIsOfferListOpen(!isOfferListOpen);
            }}
          >
            <img
              src={selectedList === "Offers" || isOfferListOpen ? OffersActive : OffersInActive}
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Offers</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isOfferListOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: (selectedList === "Offers" || isOfferListOpen) ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isOfferListOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/offer-form"}
                className={
                  (activeRoute === "/offer-form" || activeRoute === "/admin/offer-form") && selected === "Edit an Offer"
                    ? "subListItemText selectedSubListItem"
                    : (activeRoute === "/offer-form" || activeRoute === "/admin/offer-form") && selected !== "Edit an Offer"
                      ? "subListItemText selectedSubListItem"
                      : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/offer-form" } }));
                    return;
                  }
                  setSelected(isEditingOffer ? "Edit an Offer" : "Create an Offer");
                  setSelectedList("Offers");
                  // Keep the offer dropdown open
                  setIsOfferListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                {isEditingOffer ? "Edit an Offer" : "Create an Offer"}
              </Link>
              <Link
                to={"/offer-list"}
                className={
                  activeRoute === "/offer-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/offer-list" } }));
                    return;
                  }
                  setSelected("Offers List");
                  setSelectedList("Offers");
                  // Keep the offer dropdown open
                  setIsOfferListOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Offers List
              </Link>
            </div>
          )}
          <div
            className={`px-5 lg:px-[10%] flex items-center cursor-pointer ${activeRoute === "/total-income"
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              setSelected("");
              setSelectedList("Transactions");
              closeOtherDropdowns('');
              safeNavigate("/total-income");
            }}
          >
            <img
              src={
                activeRoute === "/total-income"
                  ? TransactionsActive
                  : TransactionsInActive
              }
              alt="Transactions"
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Total Income</p>
          </div>
          <div
            className={` px-5 lg:px-[10%] flex items-center cursor-pointer ${selectedList === "Assets" || isAssetsOpen
              ? "listItemDiv selectedListItem"
              : "listItemDiv"
              }`}
            onClick={() => {
              if (!isAssetsOpen) {
                closeOtherDropdowns('assets');
              }
              setIsAssetsOpen(!isAssetsOpen);
            }}
          >
            <img
              src={
                selectedList === "Assets" || isAssetsOpen
                  ? PromotionsActive
                  : PromotionsInActive
              }
            ></img>
            <p className="ListItemText ms-3 lg:ms-6">Marketing Assets</p>
            <ExpandMoreOutlined
              className={`ms-auto ${isAssetsOpen ? "transform rotate-180" : ""
                }`}
              style={{ color: selectedList === "Assets" || isAssetsOpen ? "#00ADEF" : "#8C8C8C" }}
            />
          </div>
          {isAssetsOpen && (
            <div className="gap-1 flex flex-col justify-between px-5 lg:px-[10%]">
              <Link
                to={"/add-assets"}
                className={
                  activeRoute === "/add-assets"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/add-assets" } }));
                    return;
                  }
                  setSelected("Add Assets");
                  setSelectedList("Assets");
                  // Keep the assets dropdown open
                  setIsAssetsOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                Add assets and promotions
              </Link>
              <Link
                to={"/promotions-list"}
                className={
                  activeRoute === "/promotions-list"
                    ? "subListItemText selectedSubListItem"
                    : "subListItemText"
                }
                onClick={(e) => {
                  if (sessionStorage.getItem("ADMIN_OFFER_CREATION_GUARD") === "true") {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent("attempt-exit-offer-form", { detail: { path: "/promotions-list" } }));
                    return;
                  }
                  setSelected("Promotions List");
                  setSelectedList("Assets");
                  // Keep the assets dropdown open
                  setIsAssetsOpen(true);
                  closeSidebarIfMobile();
                }}
              >
                List of Promotions
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  ) : null;
};

export default CustomSidebar;